/* unplugin-vue-components disabled */import script from "./EvidenceTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./EvidenceTable.vue?vue&type=script&setup=true&lang=ts"

import "./EvidenceTable.vue?vue&type=style&index=0&id=ff15f2ce&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff15f2ce"]])

export default __exports__